import { Injectable, ReflectiveInjector } from '@angular/core';
import { RequestOptions, RequestMethod, URLSearchParams, Http, Headers } from '@angular/http';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { LocalStorageService } from 'angular-2-local-storage';
import { Observable } from 'rxjs';

import { AppConfig } from '../app.config';
import { ApiService, SharedService, PermissionService, API_SERVICE } from './service';
import { IDataCompanyLayout, IDataAccountManager, IApiResult, IDataCountry, IDataExchange, IDataTimezone, IDataOperatingSystem } from './interface';

import * as _ from 'lodash';

declare let jQuery: any;

export interface IAPIResolverConfig {
  path?: string;
  id?: number | string;
  headers?: Headers;
  useRouteParams?: boolean;
  recursive?: boolean;
  limit?: number;
}

// tslint:disable: max-classes-per-file

@Injectable()
export class APIResolver implements Resolve<any> {
  public options: RequestOptions = this.$defaultOpts;
  public config: IAPIResolverConfig = this.$defaultConf;
  public appConfig;

  constructor(
    public api: ApiService,
    public storageService: LocalStorageService,
    public sharedService: SharedService,
    public permissionService: PermissionService,
    appConfig: AppConfig

  ) {
    this.appConfig = appConfig.getConfig();
  }

  get $defaultConf() {
    return { recursive: true, limit: 100, useRouteParams: true };
  }
  get $defaultOpts(): RequestOptions {
    return new RequestOptions({
      method: RequestMethod.Get,
      search: new URLSearchParams(),
      headers: new Headers()
    });
  }

  public resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<any> {
    // fixed issue about singleton resolvers
    // tslint:disable-next-line: one-variable-per-declaration
    const conf = _.clone<IAPIResolverConfig>(this.config), opts = _.clone<RequestOptions>(this.options); // clone current options
    this.config = _.clone<IAPIResolverConfig>(this.$defaultConf), this.options = _.clone<RequestOptions>(this.$defaultOpts); // reset using default options

    if (conf.useRouteParams && route.params['id']) { conf.id = route.params['id']; }
    opts.url = this.api.buildURL(conf.path, conf.id);
    opts.headers = conf.headers ? conf.headers : null;

    // tslint:disable-next-line: one-variable-per-declaration
    const limit = (conf.limit || this.$defaultConf.limit), data = [];
    let offset = 0;
    const _fnApiRequest = () => {
      opts.search.set('limit', limit.toString());
      opts.search.set('offset', offset.toString());
      return this.api.request(opts)
        .toPromise()
        .then((res) => {
          data.push.apply(data, res.data);
          if (res.data.length < limit || !conf.recursive) {
            return data;
          } else {
            offset = offset + limit;
            return _fnApiRequest();
          }
        })
        .catch(
          err => {
            console.error('_fnApiRequest error', err.message )
            return []
          }
        );
    };

    if (opts.url) {
      return _fnApiRequest();
    } else {
      return Observable.of([]).toPromise();
    }

  }
}

@Injectable()
export class APIMainConfigResolver extends APIResolver {
  public resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<any[]> {
    return Observable.of([this.sharedService.layout, this.sharedService.directopubConfig]).toPromise();

    // if (this.sharedService.layout) { return Observable.of([this.sharedService.layout]).toPromise(); }

    // this.config.path = 'company/layout';
    // return super.resolve(route, state)
    //   .then((data) => {
    //     const layoutData: IDataCompanyLayout = data[0];
    //     if (layoutData) {
    //       this.storageService.set('company-uid', layoutData.uid);
    //       this.sharedService.layout = layoutData;

    //       // append icons for app
    //       jQuery('meta[name=msapplication-TileImage]').attr('content', this.sharedService.layout.favicon.location);
    //       jQuery('link[rel=apple-touch-icon], link[rel=icon]').attr('href', this.sharedService.layout.favicon.location);
    //       if (this.sharedService.layout.favicon.mime) {
    //         jQuery('link[rel=apple-touch-icon], link[rel=icon]').attr('type', this.sharedService.layout.favicon.mime);
    //       } else {
    //         jQuery('link[rel=apple-touch-icon], link[rel=icon]').removeAttr('type');
    //       }
    //     } else {
    //       this.sharedService.layout = this.appConfig.default_layout;
    //     }
    //     console.log(data);
    //     return data;
    //   });
  }
}

@Injectable()
export class APIExtendedServiceCurrencyResolver extends APIResolver {
  public resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<any[]> {
    this.config.path = 'ext/service/currency';
    this.config.useRouteParams = false;
    this.config.limit = 1500;
    return super.resolve(route, state);
  }
}

@Injectable()
export class APIServiceCountryResolver extends APIResolver {
  public resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<IDataCountry[]> {
    // api service data generation or getting from cache
    return this.sharedService.getServiceApiData<IDataCountry>(API_SERVICE.COUNTRY);
  }
}

@Injectable()
export class APIServiceExchangeResolver extends APIResolver {
  public resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<IDataExchange[]> {
    // api service data generation or getting from cache
    return this.sharedService.getServiceApiData<IDataExchange>(API_SERVICE.EXCHANGE);
  }
}

@Injectable()
export class APIServiceTimezoneResolver extends APIResolver {
  public resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<IDataTimezone[]> {
    // api service data generation or getting from cache
    return this.sharedService.getServiceApiData<IDataTimezone>(API_SERVICE.TIMEZONE);
  }
}

@Injectable()
export class APIServiceOperatingSystemResolver extends APIResolver {
  public resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<IDataOperatingSystem[]> {
    // api service data generation or getting from cache
    return this.sharedService.getServiceApiData<IDataOperatingSystem>(API_SERVICE.OS); // filter only basic os Android, iOS and Windows
  }
}

// an array of services to resolve routes with data
export const COMMON_RESOLVER_PROVIDERS = [
  APIMainConfigResolver,
  APIExtendedServiceCurrencyResolver,
  APIServiceCountryResolver,
  APIServiceExchangeResolver,
  APIServiceOperatingSystemResolver,
  APIServiceTimezoneResolver,
  APIResolver,
];



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/common/resolver.ts